import { render, staticRenderFns } from "./PQRGeneral.vue?vue&type=template&id=59086799&scoped=true"
import script from "./PQRGeneral.vue?vue&type=script&lang=js"
export * from "./PQRGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59086799",
  null
  
)

export default component.exports